// Constants for UI/UX

const links = {
  origin: 'https://accesspharmacy.mhmedical.com/',
};

export default links;
